import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { LookupService } from '@admin/shared/services/lookup.service';
import { ConfigurationService } from '@admin/shared/services/configuration.service';
import { mergeMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class DashboardLookupResolveService {
  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | Observable<boolean> | Promise<boolean> {
    return this.lookupService
      .loadAllLookups()
      .pipe(mergeMap((x) => this.configurationService.loadAllConfigs()));
  }

  constructor(
    private lookupService: LookupService,
    private configurationService: ConfigurationService
  ) {}
}
